import React from "react";
import SearchIcon from "@material-ui/icons/Search";
import { InputAdornment } from "@material-ui/core";
import { CustomTextField } from "containers/gstr2a2bNewEnhancement/Utility/utility";
import downloadWhite from "images/downloadWhite.svg";
import { Button } from "@material-ui/core";
import "../../../../style.css";
import Table from "./Table";
import { useSelector } from "react-redux";

const ProbableMatch = (props) => {
  const { selectedProbable,selectedRowProbable,searchStr } = useSelector(
    (store) => store.gstr2a2bNewRecoReducer
  );
  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-start" }}>
        <div style={{ width: "35%", marginTop: "0.3em" }}>
          <CustomTextField
            style={{ backgroundColor: "white" }}
            placeholder="Search"
            className="custom-search-field"
            variant="outlined"
            size="small"
             value={searchStr}
            onChange={props.handleInputChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <Button
          onClick={() => props.handleDownload("Probable")}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          <img
            src={downloadWhite}
            alt="Download"
            style={{
              width: "30px",
              height: "20px",
              paddingBottom: "3px",
            }}
          />
        </Button>
        <Button
          onClick={props.handleOpen}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
            paddingLeft: "1.5em",
            paddingRight: "1.5em",
          }}
        >
          Filter
        </Button>
        <Button
          onClick={()=>props.handleAcceptPrGstn(selectedProbable,'PR',selectedRowProbable)}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          Accept PR
        </Button>
        <Button
          onClick={()=>props.handleAcceptPrGstn(selectedProbable,'GSTN',selectedRowProbable)}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          Accept GSTN
        </Button>
        <Button
          onClick={() => props.handlePending(selectedProbable,'PENDING',selectedRowProbable)}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
            // paddingLeft:'3em',
            // paddingRight:'3em'
          }}
        >
          Pending
        </Button>
        <Button
          onClick={()=>props.handleDeLink(selectedProbable,selectedRowProbable)}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
            // paddingLeft:'3em',
            // paddingRight:'3em'
          }}
        >
          De-Link
        </Button>
        <Button
          onClick={()=>props.handleReject(selectedProbable,'REJECT',selectedRowProbable)}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "0.8em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
            // paddingLeft:'3em',
            // paddingRight:'3em'
          }}
        >
          Reject
        </Button>
      </div>
      <Table handlePageClick={props.handlePageClick} handleSubmit={props.handleSubmit}/>
    </>
  );
};

export default ProbableMatch;
